import React, { FunctionComponent, useMemo } from 'react';
import { Box } from '@material-ui/core';
import { GetCarSpecifications_customizeCar_car } from '../../../../../graphql/queries/__generated__/GetCarSpecifications';
import modelSpecificationsService from '../../../../../service/modelSpecificationsService';
import SpecificationsDetailItem from '../../specifications/specificationsDetailItem/SpecificationsDetailItem';

export interface IModelSpecificationsContainerProps {
  car?: GetCarSpecifications_customizeCar_car;
  hasTranslation?: boolean;
}

const ModelSpecificationsList: FunctionComponent<IModelSpecificationsContainerProps> = ({ car, hasTranslation }) => {
  const specificationsList = useMemo(() => {
    const modelSpecifications = car ? modelSpecificationsService.getModelSpecifications(car) : [];

    return modelSpecificationsService.orderSpecifications(modelSpecifications);
  }, [car]);

  return (
    <Box data-test={'container:model_specifications'}>
      {specificationsList.map((feature, index: number) => {
        return (
          <SpecificationsDetailItem
            key={index}
            category={feature?.name}
            specifications={feature?.specItems}
            hasTranslation={hasTranslation}
          />
        );
      })}
    </Box>
  );
};

export default ModelSpecificationsList;
